import type React from "react"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import backgroundImage from "~/assets/arbeidsark-bg-illustration.svg"
import { FullPageLoader } from "~/components/Loader"
import { useTranslate } from "~/ur-react-hooks"
import { trpc } from "~/utils/trpc"
import RegisterSingleUser from "./RegisterSingleUser"

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  background-image: url(${backgroundImage});

  ${(props) =>
    props.theme.media.mobile &&
    `
      width: 100%;
  `}
`
const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: 394px;
  box-sizing: border-box;

  background: white;
  border-radius: 8px;
  box-shadow: 0px 8px 32px 0px rgba(27, 12, 55, 0.12);
`

const _Tabs = styled.div`
  display: flex;
  border-bottom: 2px solid ${(props) => props.theme.colors.primary99};
  border-radius: 8px 8px 0 0;
  overflow: hidden;
`

interface TabProps {
  isActive: boolean
}

const _Tab = styled.button<TabProps>`
  outline: none;
  flex: 1;
  text-align: center;
  padding: 14px;
  cursor: pointer;
  border: none;

  font-size: 14px;
  font-weight: 500;
  background: ${(props) =>
    props.isActive ? props.theme.colors.white : props.theme.colors.primary99};

  color: ${(props) =>
    props.isActive ? props.theme.colors.primary40 : props.theme.colors.gray60};
`

const Body = styled.div`
  padding: 24px;
`

enum TabType {
  SINGLE_USER = 0,
  SCHOOL = 1,
}

type RegisterProps = {}

export const Register: React.FC<RegisterProps> = () => {
  const _translations = useTranslate({
    tryFree: "subscriptions.try-for-free-30-days",
    email: "common.email",
    password: "common.password",
    singleUser: "common.single-user",
    school: "common.school",
    notAlreadyRegistered: "login.not-already-registered",
    createUser: "login.create-user",
    forgottenPassword: "login.forgotten-password",
    error: {
      createUser: "login.create-user-error",
      emailTaken: "login.email-address-already-in-use",
      wrongUsernameOrPassword: "error.wrong-username-or-password",
    },
  })

  const navigate = useNavigate()

  /*
  const [activeTab, setActiveTab] = useState<TabType>(TabType.SINGLE_USER)
*/

  const { data: isLoggedIn, isLoading: isLoggedInLoading } =
    trpc.authentication.isLoggedIn.useQuery()

  useEffect(() => {
    if (isLoggedIn) navigate("/")
  }, [isLoggedIn, navigate])

  if (isLoggedInLoading) return <FullPageLoader />

  return (
    <Wrapper>
      <Card>
        {/*
        <Tabs>
          <Tab
            isActive={activeTab === TabType.SINGLE_USER}
            onClick={() => setActiveTab(TabType.SINGLE_USER)}
          >
            {translations.singleUser}
          </Tab>
          <Tab
            isActive={activeTab === TabType.SCHOOL}
            onClick={() => setActiveTab(TabType.SCHOOL)}
          >
            {translations.school}
          </Tab>
        </Tabs>
*/}
        <Body>
          <RegisterSingleUser />
          {/*
          {activeTab === TabType.SINGLE_USER && <RegisterSingleUser />}
          {activeTab === TabType.SCHOOL && <RegisterSchool />}
*/}
        </Body>
      </Card>
    </Wrapper>
  )
}
